import { Pipe, PipeTransform } from '@angular/core';
import { ConfigProvider } from 'src/app/services/config/config';
@Pipe({
  name: 'nomenclatura',
  standalone: true
})
export class NomenclaturaPipe implements PipeTransform {

  constructor(public configProvider: ConfigProvider) { }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  transform(value: string) {
    return this.configProvider.getNomenclatura(value)
      .then(nomenclatura => {
        return nomenclatura;
      });
  }
}
